import React from 'react';
import { LuCalendarClock } from "react-icons/lu";
import { MdOutlineSick } from "react-icons/md";
import { FaUserDoctor } from "react-icons/fa6";
import { BiBody } from "react-icons/bi";
import babyComming from '../../../assets/img/cegonha.png';
import Accordion from '../../../components/Accordion/Accordion';

const AnthropometryDetails = ({
  anthropometry,
  patientName,
  patientGender,
  patientBirthDate,
  findNutritionistName,
  formatDate,
  formatGender,
  calculateAge,
  formatPhysicalActivityLevel,
  formatPhysicalActivityFrequency,
  formatedClassificationBMI,
  formatedClassificationBray,
  formatedClassificationBernadinelli,
  formatedClassificatoinBlackburn,
  formatedClassificationInternalFat,
  formatedClassificationMuscleMass,
  formatedClassificationLeanWeightType,
  formatedClassificationWaistCircumference,
  formatedClassificationChildBMI,
  formatedClassificationElderlyBMI,
  formatedClassificationBiotype,
  formatedClassificationWaist,
  formatedClassificationLeanMass,
  formatedDiagnosisMuscle,
}) => {
  return (
    <Accordion
      key={anthropometry.measurement_date}
      title={
        <div className="row-getAnthropometryBox">
          <div className="colAntBox">
            <label className="labelAnt">Data</label>
            <div className="rowAntBox">
              <LuCalendarClock /> {formatDate(anthropometry.measurement_date)}
            </div>
          </div>
          <div className="colAntBox">
            <label className="labelAnt">Paciente</label>
            <div className="rowAntBox">
              <MdOutlineSick /> {patientName}
            </div>
          </div>
          <div className="colAntBox">
            <label className="labelAnt">Profissional</label>
            <div className="rowAntBox">
              <FaUserDoctor /> {findNutritionistName(anthropometry.nutritionist_id)}
            </div>
          </div>
          <div className="colAntBox">
            <label className="labelAnt">IMC</label>
            <div className="rowAntBox">
              {anthropometry.bmi} | <BiBody /> | {formatedClassificationBMI(anthropometry.bmi_classification_code)} | {formatedClassificationBray(anthropometry.bray_classification)}
            </div>
          </div>
        </div>
      }
    >
      {/* Accordion: Resultados da Avaliação */}
      <div className="row-Anthropometry">
        <h5 className='anthropometryTitle'>Resultados da Avaliação</h5>
        <div className="row-box">
          <div className="row-line">
            <label>Gênero</label>
            <div className="return-data">{formatGender(patientGender)}</div>
          </div>
          <div className="row-line">
            <label>Data de Nascimento</label>
            <div className="return-data">{formatDate(patientBirthDate)}</div>
          </div>
          <div className="row-line">
            <label>Idade</label>
            <div className="return-data">{calculateAge(patientBirthDate)}</div>
          </div>
          <div className="row-line">
            <label>Altura</label>
            <div className="return-data">{anthropometry.height ? `${anthropometry.height} cm` : 'N/A'}</div>
          </div>
          <div className="row-line">
            <label>Peso Atual</label>
            <div className="return-data">{anthropometry.current_weight ? `${anthropometry.current_weight} kg` : 'N/A'}</div>
          </div>
          <div className="row-line">
            <label>IMC</label>
            <div className="return-data">
              {anthropometry.bmi ? `${anthropometry.bmi} kg/m²` : 'N/A'} |
              {formatedClassificationBMI(anthropometry.bmi_classification_code) || 'N/A'}
            </div>
          </div>
          <div className="row-line">
            <label>Peso Teórico (PT)</label>
            <div className="return-data">{anthropometry.theoretical_weight ? `${anthropometry.theoretical_weight} kg` : 'N/A'}</div>
          </div>
          <div className="row-line">
            <label>Classificação Biotipo (Bernadinelli)</label>
            <div className="return-data">{formatedClassificationBernadinelli(anthropometry.pg_classification_code) || 'N/A'}</div>
          </div>
          <div className="row-line">
            <label>Classificação OMS (George A. Bray)</label>
            <div className="return-data">{formatedClassificationBray(anthropometry.bray_classification) || 'N/A'}</div>
          </div>
          <div className="row-line">
            <label>Classificação Nutricional (Blackburn)</label>
            <div className="return-data">{formatedClassificatoinBlackburn(anthropometry.blackburn_classification) || 'N/A'}</div>
          </div>
          <div className="row-line">
            <label>AMB (Área Muscular do Braço)</label>
            <div className="return-data">{anthropometry.arm_muscle_area ? `${anthropometry.arm_muscle_area} cm²` : 'N/A'}</div>
          </div>
          <div className="row-line">
            <label>AMBc (Área Muscular Corrigida)</label>
            <div className="return-data">{anthropometry.arm_muscle_area_adj ? `${anthropometry.arm_muscle_area_adj} cm²` : 'N/A'}</div>
          </div>
          <div className="row-line">
            <label>Classificação Musculatura</label>
            <div className="return-data">{formatedClassificationMuscleMass(anthropometry.muscle_mass_classification) || 'N/A'}</div>
          </div>
          <div className="row-line">
            <label>TMB</label>
            <div className="return-data">{anthropometry.tmb ? `${anthropometry.tmb} kcal/dia` : 'N/A'}</div>
          </div>
          <div className="row-line">
            <label>VET</label>
            <div className="return-data">{anthropometry.vet ? `${anthropometry.vet} kcal/dia` : 'N/A'}</div>
          </div>
        </div>
      </div>
      {/* Paciente Feminina */}
      {patientGender === 'female' && anthropometry.gestational_age && (
        <div className="row-Anthropometry">
          <div className="titleLine">
            <h5 className='anthropometryTitle'>Informações da Gestação</h5>
            <div className="sliding-image-container">
              <img src={babyComming} alt="cegonha" />
            </div>
          </div>
          <div className="row-box">
            <div className="row-line">
              <label>Idade Gestacional</label>
              <div className="return-data">{`${anthropometry.gestational_age} semanas`}</div>
            </div>
            <div className="row-line">
              <label>DPP</label>
              <div className="return-data">{formatDate(anthropometry.ddp_date)}</div>
            </div>
            <div className="row-line">
              <label>DUM</label>
              <div className="return-data">{formatDate(anthropometry.last_period_date)}</div>
            </div>
            <div className="row-line">
              <label>Peso Pré-Gestacional</label>
              <div className="return-data">{anthropometry.ppg_weight ? `${anthropometry.ppg_weight} kg` : 'N/A'}</div>
            </div>
            <div className="row-line">
              <label>IMC Gestacional</label>
              <div className="return-data">{anthropometry.gestational_imc ? `${anthropometry.gestational_imc} kg/m²` : 'N/A'}</div>
            </div>
            <div className="row-line">
              <label>Ganho de Peso Recomendado</label>
              <div className="return-data">{anthropometry.recomended_weight_gain ? `${anthropometry.recomended_weight_gain} kg` : 'N/A'}</div>
            </div>
          </div>
        </div>
      )}

      {/* Accordion: Classificações */}
      <Accordion title="Classificações">
        <div className="row-getAnthropometry">
          <div className="colAnt">
            <label htmlFor='pg_classification_code'>Código da Classificação PG</label>
            <div>{formatedClassificationBernadinelli(anthropometry.pg_classification_code) ?? 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor='body_fat_percentage'>Percentual de Gordura Corporal</label>
            <div>{anthropometry.body_fat_percentage ?? 'N/A'} %</div>
          </div>
          <div className="colAnt">
            <label htmlFor='ideal_fat_percentage'>Percentual Ideal de Gordura</label>
            <div>{anthropometry.ideal_fat_percentage ?? 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor='gi_percentage_type'>Tipo de Percentual GI</label>
            <div>{formatedClassificationInternalFat(anthropometry.gi_percentage_type) ?? 'N/A'} %</div>
          </div>
          <div className="colAnt">
            <label htmlFor='total_body_water'>Total Corporal de Água</label>
            <div>{anthropometry.total_body_water ?? 'N/A'} %</div>
          </div>
          <div className="colAnt">
            <label htmlFor='lean_weight_type'>Tipo de Peso Magro</label>
            <div>{formatedClassificationLeanWeightType(anthropometry.lean_weight_type) ?? 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor='muscle_mass_weight'>Peso da Massa Corporal</label>
            <div>{anthropometry.muscle_mass_weight ?? 'N/A'} kg</div>
          </div>
          <div className="colAnt">
            <label htmlFor='physical_activity'>Frequência da Atividade Física</label>
            <div>{formatPhysicalActivityFrequency(anthropometry.physical_activity_frequency) ?? 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor='physical_activity_level'>Nível da Atividade Física</label>
            <div>{formatPhysicalActivityLevel(anthropometry.physical_activity_level) ?? 'N/A'}</div>
          </div>
        </div>
      </Accordion>

      {/* Accordion: Medidas Essencicais */}
      <Accordion title="Medidas Essenciais">
        <div className="row-getAnthropometry">
          <div className="colAnt">
            <label>Altura</label>
            <div>{anthropometry.height ? `${anthropometry.height} cm` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label>Peso Atual</label>
            <div>{anthropometry.current_weight ? `${anthropometry.current_weight} kg` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label>IMC</label>
            <div>{anthropometry.bmi ? `${anthropometry.bmi} kg/m²` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label>Classificação do IMC</label>
            <div>{formatedClassificationBMI(anthropometry.bmi_classification_code) || 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label>Quetelet</label>
            <div>{anthropometry.bmi ? `${anthropometry.bmi} kg/m²` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label>Peso Teórico (PT)</label>
            <div>{anthropometry.theoretical_weight ? `${anthropometry.theoretical_weight} kg` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label>CMB (Circunferência Muscular do Braço)</label>
            <div>{anthropometry.arm_circumference ? `${anthropometry.arm_circumference} cm` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label>AMB (Área Muscular do Braço)</label>
            <div>{anthropometry.arm_muscle_area ? `${anthropometry.arm_muscle_area} cm²` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label>AMBc (AMB Corrigida)</label>
            <div>{anthropometry.arm_muscle_area_adj ? `${anthropometry.arm_muscle_area_adj} cm²` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label>AB (Área do Braço)</label>
            <div>{anthropometry.arm_area ? `${anthropometry.arm_area} mm²` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label>AGB (Área Gordurosa do Braço)</label>
            <div>{anthropometry.arm_fat_area ? `${anthropometry.arm_fat_area} mm²` : 'N/A'}</div>
          </div>
        </div>
      </Accordion>

      {/* Accordion: Braços */}
      <Accordion title={"Braços"}>
        <div className="row-getAnthropometry">
          <div className="colAnt">
            <label htmlFor='left_arm'>Braço Esquerdo</label>
            <div>{anthropometry.left_arm ?? 'N/A'} cm</div>
          </div>
          <div className="colAnt">
            <label htmlFor='right_arm'>Braço Direito</label>
            <div>{anthropometry.right_arm ?? 'N/A'} cm</div>
          </div>
          <div className="colAnt">
            <label htmlFor='left_biceps'>Bíceps Esquerdo</label>
            <div>{anthropometry.left_bicep ?? 'N/A'} cm</div>
          </div>
          <div className="colAnt">
            <label htmlFor='right_biceps'>Bíceps Direito</label>
            <div>{anthropometry.right_bicep ?? 'N/A'} cm</div>
          </div>
          <div className="colAnt">
            <label htmlFor='left_forearm'>Antebraço Esquerdo</label>
            <div>{anthropometry.left_forearm ?? 'N/A'} cm</div>
          </div>
          <div className="colAnt">
            <label htmlFor='right_forearm'>Antebraço Direito</label>
            <div>{anthropometry.right_forearm ?? 'N/A'} cm</div>
          </div>
          <div className="colAnt">
            <label htmlFor='left_hand'>Mão Esquerda</label>
            <div>{anthropometry.left_hand ?? 'N/A'} cm</div>
          </div>
          <div className="colAnt">
            <label htmlFor='right_hand'>Mão Direita</label>
            <div>{anthropometry.right_hand ?? 'N/A'} cm</div>
          </div>
          <div className="colEmpty">
          </div>
          <div className="colEmpty">
          </div>
        </div>

      </Accordion>

      {/* Accordion: Pernas */}
      <Accordion title={"Pernas"}>
        <div className="row-getAnthropometry">
          <div className="colAnt">
            <label htmlFor='left_leg'>Perna Esquerda</label>
            <div>{anthropometry.left_leg ?? 'N/A'} cm</div>
          </div>
          <div className="colAnt">
            <label htmlFor='right_leg'>Perna Direita</label>
            <div>{anthropometry.right_leg ?? 'N/A'} cm</div>
          </div>
          <div className="colAnt">
            <label htmlFor='left_thigh'>Coxa Esquerda</label>
            <div>{anthropometry.left_thigh ?? 'N/A'} cm</div>
          </div>
          <div className="colAnt">
            <label htmlFor='right_thigh'>Coxa Direita</label>
            <div>{anthropometry.right_thigh ?? 'N/A'} cm</div>
          </div>
          <div className="colAnt">
            <label htmlFor='left_lower_leg'>Perna Inferior Esquerda</label>
            <div>{anthropometry.left_lower_leg ?? 'N/A'} cm</div>
          </div>
          <div className="colAnt">
            <label htmlFor='right_lower_leg'>Perna Inferior Direita</label>
            <div>{anthropometry.right_lower_leg ?? 'N/A'} cm</div>
          </div>
          <div className="colAnt">
            <label htmlFor='left_foot'>Pé Esquerdo</label>
            <div>{anthropometry.left_foot ?? 'N/A'} cm</div>
          </div>
          <div className="colAnt">
            <label htmlFor='right_foot'>Pé Direito</label>
            <div>{anthropometry.right_foot ?? 'N/A'} cm</div>
          </div>
          <div className="colEmpty">

          </div>
          <div className="colEmpty">

          </div>
        </div>
      </Accordion>

      {/* Accordion: Circunferências */}
      <Accordion title="Circunferências">
        <div className="row-getAnthropometry">
          <div className="colAnt">
            <label htmlFor="waist_circumference">Cintura</label>
            <div>{anthropometry.waist_circumference ? `${anthropometry.waist_circumference} cm` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor="waist_classification">Classificação da Cintura</label>
            <div>{formatedClassificationWaistCircumference(anthropometry.waist_classification) || 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor="hip_circumference">Quadril</label>
            <div>{anthropometry.hip_circumference ? `${anthropometry.hip_circumference} cm` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor="waist_hip_ratio">Relação Cintura-Quadril (RCQ)</label>
            <div>{anthropometry.waist_hip_ratio ? anthropometry.waist_hip_ratio : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor="waist_hip_classification">Classificação RCQ</label>
            <div>{anthropometry.waist_hip_classification || 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor="neck_circumference">Pescoço</label>
            <div>{anthropometry.neck_circumference ? `${anthropometry.neck_circumference} cm` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor="arm_circumference">Braço</label>
            <div>{anthropometry.arm_circumference ? `${anthropometry.arm_circumference} cm` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor="forearm_circumference">Antebraço</label>
            <div>{anthropometry.forearm_circumference ? `${anthropometry.forearm_circumference} cm` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor="thigh_circumference">Coxa</label>
            <div>{anthropometry.thigh_circumference ? `${anthropometry.thigh_circumference} cm` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor="calf_circumference">Panturrilha</label>
            <div>{anthropometry.calf_circumference ? `${anthropometry.calf_circumference} cm` : 'N/A'}</div>
          </div>
        </div>
      </Accordion>

      {/* Accordion: Diâmetros e Altura dos Ossos  */}
      <Accordion title={"Diâmetros e Alturas Osseas"}>
        <div className="row-getAnthropometry">
          <div className="colAnt">
            <label htmlFor='knee_height'>Altura do Joelho</label>
            <div>{anthropometry.knee_height ?? 'N/A'} cm</div>
          </div>
          <div className="colAnt">
            <label htmlFor='radial_diameter'>Diâmetro do Radial</label>
            <div>{anthropometry.radial_diameter ?? 'N/A'} cm</div>
          </div>
          <div className="colAnt">
            <label htmlFor='femur_diameter'>Diâmetro do Fêmur</label>
            <div>{anthropometry.femur_diameter ?? 'N/A'} cm</div>
          </div>
          <div className="colAnt">
            <label htmlFor='humeral_diameter'>Diâmetro do Úmero</label>
            <div>{anthropometry.humeral_diameter ?? 'N/A'} cm</div>
          </div>
        </div>
      </Accordion>

      {/* Accordion: Dobras Cultâneas */}
      <Accordion title="Dobras Cutâneas">
        <div className="row-getAnthropometry">
          <div className="colAnt">
            <label htmlFor="triceps_skinfold">Tríceps</label>
            <div>{anthropometry.triceps_skinfold ? `${anthropometry.triceps_skinfold} mm` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor="subscapular_skinfold">Subescapular</label>
            <div>{anthropometry.subscapular_skinfold ? `${anthropometry.subscapular_skinfold} mm` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor="suprailiac_skinfold">Suprailíaca</label>
            <div>{anthropometry.suprailiac_skinfold ? `${anthropometry.suprailiac_skinfold} mm` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor="abdominal_skinfold">Abdominal</label>
            <div>{anthropometry.abdominal_skinfold ? `${anthropometry.abdominal_skinfold} mm` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor="chest_skinfold">Peitoral</label>
            <div>{anthropometry.chest_skinfold ? `${anthropometry.chest_skinfold} mm` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor="midaxillary_skinfold">Média Axilar</label>
            <div>{anthropometry.midaxillary_skinfold ? `${anthropometry.midaxillary_skinfold} mm` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor="thigh_skinfold">Coxa</label>
            <div>{anthropometry.thigh_skinfold ? `${anthropometry.thigh_skinfold} mm` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor="calf_skinfold">Panturrilha</label>
            <div>{anthropometry.calf_skinfold ? `${anthropometry.calf_skinfold} mm` : 'N/A'}</div>
          </div>
        </div>
      </Accordion>

      {/* Accordion: Composição Corporal */}
      <Accordion title="Composição Corporal">
        <div className="row-getAnthropometry">
          <div className="colAnt">
            <label htmlFor="body_fat_weight">Peso de Gordura Corporal</label>
            <div>{anthropometry.body_fat_weight ? `${anthropometry.body_fat_weight} kg` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor="lean_mass_weight">Peso da Massa Magra</label>
            <div>{anthropometry.lean_mass_weight ? `${anthropometry.lean_mass_weight} kg` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor="residual_mass_weight">Massa Residual</label>
            <div>{anthropometry.residual_mass_weight ? `${anthropometry.residual_mass_weight} kg` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor="ideal_weight">Peso Ideal</label>
            <div>{anthropometry.ideal_weight ? `${anthropometry.ideal_weight} kg` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor="excess_weight">Excesso de Peso</label>
            <div>{anthropometry.excess_weight ? `${anthropometry.excess_weight} kg` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor="weight_deficit">Déficit de Peso</label>
            <div>{anthropometry.weight_deficit ? `${anthropometry.weight_deficit} kg` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor="muscle_mass_percentage">% de Massa Muscular</label>
            <div>{anthropometry.muscle_mass_percentage ? `${anthropometry.muscle_mass_percentage} %` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor="fat_mass_percentage">% de Massa Gorda</label>
            <div>{anthropometry.fat_mass_percentage ? `${anthropometry.fat_mass_percentage} %` : 'N/A'}</div>
          </div>
        </div>
      </Accordion>

      {/* Accordion: Metabolismo e Gasto Energético */}
      <Accordion title="Metabolismo e Gasto Energético (TMB / VET / FA)">
        <div className="row-getAnthropometry">
          <div className="colAnt">
            <label htmlFor="tmb">Taxa Metabólica Basal (TMB)</label>
            <div>{anthropometry.tmb ? `${anthropometry.tmb} kcal/dia` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor="physical_activity_level">Nível de Atividade Física (NAF)</label>
            <div>{formatPhysicalActivityLevel(anthropometry.physical_activity_level) ?? 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor="vet">Valor Energético Total (VET)</label>
            <div>{anthropometry.vet ? `${anthropometry.vet} kcal/dia` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor="vet_final">VET Final (com redução ou acréscimo)</label>
            <div>{anthropometry.vet_final ? `${anthropometry.vet_final} kcal/dia` : 'N/A'}</div>
          </div>
          <div className="colAnt">
            <label htmlFor="vet_final_weight">Meta de Peso Alvo (VET)</label>
            <div>{anthropometry.vet_final_weight ? `${anthropometry.vet_final_weight} kcal/dia` : 'N/A'}</div>
          </div>
        </div>
      </Accordion>

      {/* Accordion: Outros Índices */}
      < Accordion title={"Outros Índices"} >
        <div className="row-getAnthropometry">
          {/* <div className="colAnt">
                          <label htmlFor='age_years'>Idade / Anos</label>
                          <div>{anthropometry.age_years ?? 'N/A'}</div>
                        </div>
                        <div className="colAnt">
                          <label htmlFor='age_months'>Idade / Meses</label>
                          <div>{anthropometry.age_months ?? 'N/A'}</div>
                        </div> */}
          <div className="colAnt">
            <label htmlFor='reference_estimated_weight'>Peso de Referência Esimado</label>
            <div>{anthropometry.reference_estimated_weight ?? 'N/A'} kg</div>
          </div>
          <div className="colAnt">
            <label htmlFor='fat_mass_weight'>Peso da Massa Gorda</label>
            <div>{anthropometry.fat_mass_weight ?? 'N/A'} kg</div>
          </div>
          <div className="colAnt">
            <label htmlFor='ppr_time'>Perda de Peso Recente - PPR</label>
            <div>{anthropometry.ppr_time ?? 'N/A'} kg</div>
          </div>
          {/* <div className="colAnt">
                          <label htmlFor='vet_id'>VET ID</label>
                          <div>{anthropometry.vet_id ?? 'N/A'}</div>
                        </div> */}
          {/* <div className="colAnt">
                          <label htmlFor='vet_reduction_id'>VET Redução ID</label>
                          <div>{anthropometry.vet_reduction_id ?? 'N/A'}</div>
                        </div> */}
          <div className="colAnt">
            <label htmlFor='bray_classification'>Classificação OMS (Gerorge A. Bray)</label>
            <div className="return-data">{anthropometry.bray_classification ? `${formatedClassificationBray(anthropometry.bray_classification)}` : 'N/A'}</div>
          </div>
          {/* <div className="colAnt">
                          <label htmlFor='mcm'>MCM</label>
                          <div>{anthropometry.mcm ?? 'N/A'} kg</div>
                        </div> */}
        </div>
      </Accordion>

      {/* Accordion: Diagnóstico */}
      <Accordion title={"Diagnóstico"}>
        <div className="row-getAnthropometry">
          <div className="colAnt">
            <label htmlFor='diagnosis'>Diagnóstico</label>
            <div>{anthropometry.diagnosis ?? 'N/A'}</div>
          </div>
          <div className="colEmpty"></div>
          <div className="colEmpty"></div>
        </div>
      </Accordion>

    </Accordion>
  );
};

export default AnthropometryDetails;